import React from "react";
import { AddressImportError } from "api/sms-api";
import i18n from "i18n";
import { List } from "antd";

interface ImportErrorProps {
  error: AddressImportError;
}

const ImportError: React.FC<ImportErrorProps> = (props) => {
  const description = i18n.t(
    `addresses.importErrorDescription.${props.error.errorType}`
  );
  return (
    <List.Item>
      {`${i18n.t("addresses.importErrorLine", {
        line: props.error.lineNumber,
      })}${description}`}
    </List.Item>
  );
};

export default ImportError;
